"use client";

import { useState } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import HeroSection from './components/HeroSection';
import FeaturedDishes from './components/FeaturedDishes';
import RestaurantStory from './components/RestaurantStory';
import CustomerReviews from './components/CustomerReviews';
import ReservationCTA from './components/ReservationCTA';
import { Language } from '@/lib/i18n';

export default function Homepage() {
  const [language, setLanguage] = useState<Language>('en');

  return (
    <>
      <Header language={language} onLanguageChange={setLanguage} />
      <main className="pt-20">
        <HeroSection language={language} />
        <FeaturedDishes language={language} />
        <RestaurantStory language={language} />
        <CustomerReviews language={language} />
        <ReservationCTA language={language} />
      </main>
      <Footer />
    </>
  );
}